/* CANGURERA — interacciones propias (prefijo cg-). Sin librerías. */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un solo observador) ---------- */
  function initReveals(root) {
    var els = (root || document).querySelectorAll('.cg-reveal:not(.cg-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cg-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('cg-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Parallax suave del hero ---------- */
  function initParallax() {
    var imgs = document.querySelectorAll('[data-cg-parallax]');
    if (!imgs.length || reduceMotion) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var fuerza = parseFloat(img.getAttribute('data-cg-parallax')) || 0;
        var rect = img.parentElement.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > window.innerHeight) return;
        img.style.transform = 'translate3d(0,' + (-rect.top * fuerza / 100) + 'px,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- Cifras que cuentan al aparecer ---------- */
  function initContadores() {
    var nums = document.querySelectorAll('[data-cg-contar]');
    if (!nums.length) return;
    function animar(el) {
      var fin = parseFloat(el.getAttribute('data-cg-contar')) || 0;
      if (reduceMotion) { el.textContent = fin; return; }
      var dur = 1600, t0 = null;
      function paso(t) {
        if (!t0) t0 = t;
        var p = Math.min((t - t0) / dur, 1);
        el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(paso);
      }
      requestAnimationFrame(paso);
    }
    if (!('IntersectionObserver' in window)) { nums.forEach(animar); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.5 });
    nums.forEach(function (n) { io.observe(n); });
  }

  /* ---------- Puntos de "lo que le cabe" (toque en móvil) ---------- */
  function initPuntos() {
    document.querySelectorAll('.cg-cap__pin').forEach(function (pin) {
      pin.addEventListener('click', function () {
        var punto = pin.closest('.cg-cap__punto');
        var activo = punto.classList.contains('cg-activo');
        punto.parentElement.querySelectorAll('.cg-cap__punto').forEach(function (p) { p.classList.remove('cg-activo'); });
        if (!activo) punto.classList.add('cg-activo');
      });
    });
  }

  /* ---------- Selector de colores de la portada ---------- */
  function initColores() {
    document.querySelectorAll('[data-cg-colores]').forEach(function (box) {
      var botones = box.querySelectorAll('.cg-col__muestra');
      var fotos = box.querySelectorAll('.cg-col__escenario img');
      var nombre = box.querySelector('[data-cg-col-nombre]');
      var etiqueta = box.querySelector('.cg-col__nombre');
      var estado = box.querySelector('[data-cg-col-estado]');
      var enlace = box.querySelector('[data-cg-col-enlace]');
      botones.forEach(function (b, i) {
        b.addEventListener('click', function () {
          botones.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
          b.setAttribute('aria-pressed', 'true');
          fotos.forEach(function (f, j) { f.classList.toggle('cg-activa', j === i); });
          if (nombre) nombre.textContent = b.getAttribute('data-nombre');
          if (etiqueta) etiqueta.textContent = b.getAttribute('data-nombre');
          if (estado) estado.textContent = b.getAttribute('data-estado');
          if (enlace) enlace.href = b.getAttribute('data-url');
        });
      });
    });
  }

  /* ---------- Añadir al carrito (abre el carrito lateral de Dawn) ---------- */
  function initFormularios() {
    document.querySelectorAll('form[data-cg-form]').forEach(function (form) {
      form.addEventListener('submit', function (ev) {
        var drawer = document.querySelector('cart-drawer');
        if (!drawer || typeof drawer.renderContents !== 'function' || !window.fetch) return;
        ev.preventDefault();
        var boton = form.querySelector('[type="submit"]');
        var aviso = form.parentElement.querySelector('[data-cg-aviso]');
        if (boton) { boton.setAttribute('aria-busy', 'true'); boton.disabled = true; }
        var datos = new FormData(form);
        datos.append('sections', 'cart-drawer,cart-icon-bubble');
        datos.append('sections_url', window.location.pathname);
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
          method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: datos
        })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) { if (aviso) aviso.textContent = res.description || res.message; return; }
            if (aviso) aviso.textContent = '';
            drawer.classList.remove('is-empty');
            drawer.renderContents(res);
          })
          .catch(function () { form.submit(); })
          .finally(function () {
            if (boton) { boton.removeAttribute('aria-busy'); boton.disabled = boton.hasAttribute('data-cg-agotado'); }
          });
      });
    });
  }

  /* ---------- Página de producto: galería, variantes, cantidad, barra fija ---------- */
  function initProducto() {
    document.querySelectorAll('[data-cg-pdp]').forEach(function (pdp) {
      var principal = pdp.querySelector('[data-cg-principal]');
      var minis = Array.prototype.slice.call(pdp.querySelectorAll('.cg-pdp__mini'));
      var actual = 0;
      function mostrar(i) {
        if (!minis.length || !principal) return;
        actual = (i + minis.length) % minis.length;
        var m = minis[actual];
        principal.style.opacity = 0;
        setTimeout(function () {
          principal.src = m.getAttribute('data-src');
          principal.srcset = m.getAttribute('data-srcset') || '';
          principal.alt = m.getAttribute('data-alt') || '';
          principal.style.opacity = 1;
        }, 150);
        minis.forEach(function (x, j) { x.setAttribute('aria-current', j === actual ? 'true' : 'false'); });
        m.scrollIntoView({ block: 'nearest', inline: 'nearest' });
      }
      minis.forEach(function (m, i) { m.addEventListener('click', function () { mostrar(i); }); });
      var prev = pdp.querySelector('.cg-pdp__flecha--prev');
      var next = pdp.querySelector('.cg-pdp__flecha--next');
      if (prev) prev.addEventListener('click', function () { mostrar(actual - 1); });
      if (next) next.addEventListener('click', function () { mostrar(actual + 1); });

      // Deslizar con el dedo en móvil
      if (principal) {
        var x0 = null;
        principal.parentElement.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        principal.parentElement.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) mostrar(actual + (dx < 0 ? 1 : -1));
          x0 = null;
        });
      }

      // Variantes
      var jsonEl = pdp.querySelector('[data-cg-variantes]');
      var variantes = jsonEl ? JSON.parse(jsonEl.textContent) : [];
      var inputId = pdp.querySelector('input[name="id"]');
      var botones = pdp.querySelectorAll('[data-cg-comprar]');
      var precioEls = pdp.querySelectorAll('[data-cg-precio]');
      var antesEls = pdp.querySelectorAll('[data-cg-antes]');
      var stock = pdp.querySelector('[data-cg-stock]');
      var formato = pdp.getAttribute('data-cg-moneda') || '${{amount}}';
      var txtComprar = pdp.getAttribute('data-cg-txt-comprar');
      var txtAgotado = pdp.getAttribute('data-cg-txt-agotado');
      var txtStock = pdp.getAttribute('data-cg-txt-stock');
      var txtSin = pdp.getAttribute('data-cg-txt-sin');

      function dinero(cent) {
        var n = (cent / 100).toFixed(2).split('.');
        var miles = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        return formato
          .replace(/\{\{\s*amount_no_decimals\s*\}\}/, miles)
          .replace(/\{\{\s*amount\s*\}\}/, miles + '.' + n[1])
          .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, n[0] + ',' + n[1]);
      }

      function actualizar() {
        var elegidos = Array.prototype.map.call(pdp.querySelectorAll('.cg-pdp__opcion'), function (fs) {
          var c = fs.querySelector('input:checked');
          var leyenda = fs.querySelector('[data-cg-opcion-valor]');
          if (c && leyenda) leyenda.textContent = c.value;
          return c ? c.value : null;
        });
        var v = variantes.filter(function (x) {
          return x.options.every(function (o, i) { return o === elegidos[i]; });
        })[0];
        if (!v) return;
        if (inputId) inputId.value = v.id;
        precioEls.forEach(function (el) { el.textContent = dinero(v.price); });
        antesEls.forEach(function (el) {
          el.textContent = v.compare_at_price > v.price ? dinero(v.compare_at_price) : '';
        });
        botones.forEach(function (b) {
          b.disabled = !v.available;
          if (v.available) b.removeAttribute('data-cg-agotado'); else b.setAttribute('data-cg-agotado', '');
          var t = b.querySelector('[data-cg-txt]');
          if (t) t.textContent = v.available ? txtComprar : txtAgotado;
        });
        if (stock) {
          stock.classList.toggle('cg-sin', !v.available);
          stock.querySelector('span').textContent = v.available ? txtStock : txtSin;
        }
        if (v.featured_media_id) {
          var idx = minis.findIndex(function (m) { return m.getAttribute('data-media-id') == v.featured_media_id; });
          if (idx > -1 && idx !== actual) mostrar(idx);
        }
        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }
      pdp.querySelectorAll('.cg-pdp__opcion input').forEach(function (inp) { inp.addEventListener('change', actualizar); });

      // Cantidad
      var cant = pdp.querySelector('[data-cg-cantidad]');
      if (cant) {
        pdp.querySelectorAll('[data-cg-cant]').forEach(function (b) {
          b.addEventListener('click', function () {
            var v = (parseInt(cant.value, 10) || 1) + parseInt(b.getAttribute('data-cg-cant'), 10);
            cant.value = Math.max(1, v);
          });
        });
      }

      // Barra fija de compra en móvil
      var fija = pdp.querySelector('.cg-pdp__fija');
      var zona = pdp.querySelector('.cg-pdp__comprar');
      if (fija && zona && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var e = entries[0];
          fija.classList.toggle('cg-mostrar', !e.isIntersecting && e.boundingClientRect.top < 0);
        }).observe(zona);
        var btnFija = fija.querySelector('button');
        if (btnFija) btnFija.addEventListener('click', function () {
          var b = zona.querySelector('[type="submit"]');
          if (b && !b.disabled) b.click(); else zona.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    });
  }

  /* ---------- Portada con escenas que rotan ---------- */
  function initHero() {
    document.querySelectorAll('[data-cg-hero]').forEach(function (hero) {
      if (hero.dataset.cgListo) return;
      hero.dataset.cgListo = '1';
      var escenas = hero.querySelectorAll('.cg-hero__escena');
      var puntos = hero.querySelectorAll('.cg-hero__punto');
      if (escenas.length < 2) return;
      var actual = 0, timer = null;
      var seg = (parseInt(hero.getAttribute('data-cg-auto'), 10) || 6) * 1000;
      var auto = hero.getAttribute('data-cg-autoplay') === 'true' && !reduceMotion;
      if (!auto) hero.classList.add('cg-hero--manual');
      function ir(i) {
        actual = (i + escenas.length) % escenas.length;
        escenas.forEach(function (e, j) {
          var on = j === actual;
          e.classList.toggle('cg-activa', on);
          if (on) e.removeAttribute('aria-hidden'); else e.setAttribute('aria-hidden', 'true');
          e.querySelectorAll('a').forEach(function (a) { if (on) a.removeAttribute('tabindex'); else a.setAttribute('tabindex', '-1'); });
        });
        puntos.forEach(function (p, j) {
          p.classList.remove('cg-activa');
          p.setAttribute('aria-selected', j === actual ? 'true' : 'false');
        });
        // reinicia la barra de progreso
        if (puntos[actual]) { void puntos[actual].offsetWidth; puntos[actual].classList.add('cg-activa'); }
      }
      function siguiente() { ir(actual + 1); }
      function arrancar() { if (!auto) return; clearInterval(timer); timer = setInterval(siguiente, seg); hero.classList.remove('cg-hero--pausa'); }
      function parar() { clearInterval(timer); hero.classList.add('cg-hero--pausa'); }
      puntos.forEach(function (p) {
        p.addEventListener('click', function () { ir(parseInt(p.getAttribute('data-cg-ir'), 10)); arrancar(); });
      });
      // deslizar con el dedo
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 50) { ir(actual + (dx < 0 ? 1 : -1)); arrancar(); }
        x0 = null;
      });
      document.addEventListener('visibilitychange', function () { if (document.hidden) parar(); else arrancar(); });
      // en el editor de Shopify: al seleccionar una escena, mostrarla
      document.addEventListener('shopify:block:select', function (e) {
        var idx = Array.prototype.indexOf.call(escenas, e.target);
        if (idx > -1) { ir(idx); parar(); }
      });
      arrancar();
    });
  }

  /* ---------- Pestañas "Elige tu ritmo" ---------- */
  function initPerfiles() {
    document.querySelectorAll('[data-cg-perfiles]').forEach(function (box) {
      if (box.dataset.cgListo) return;
      box.dataset.cgListo = '1';
      var tabs = Array.prototype.slice.call(box.querySelectorAll('.cg-per__tab'));
      var paneles = box.querySelectorAll('.cg-per__panel');
      function mostrar(i, foco) {
        tabs.forEach(function (t, j) {
          var on = j === i;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          paneles[j].hidden = !on;
          paneles[j].classList.toggle('cg-activa', on);
        });
        if (foco) tabs[i].focus();
      }
      tabs.forEach(function (t, i) {
        t.tabIndex = i === 0 ? 0 : -1;
        t.addEventListener('click', function () { mostrar(i); });
        t.addEventListener('keydown', function (e) {
          if (e.key === 'ArrowRight') { e.preventDefault(); mostrar((i + 1) % tabs.length, true); }
          if (e.key === 'ArrowLeft') { e.preventDefault(); mostrar((i - 1 + tabs.length) % tabs.length, true); }
        });
      });
      document.addEventListener('shopify:block:select', function (e) {
        var idx = tabs.indexOf(e.target);
        if (idx > -1) mostrar(idx);
      });
    });
  }

  function initTodo(root) {
    initReveals(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initTodo(document);
    initParallax();
    initContadores();
    initPuntos();
    initColores();
    initFormularios();
    initProducto();
    initHero();
    initPerfiles();
  });

  // Que todo funcione también al editar en el personalizador de Shopify
  document.addEventListener('shopify:section:load', function (e) {
    initTodo(e.target);
    initContadores();
    initPuntos();
    initColores();
    initFormularios();
    initProducto();
    initHero();
    initPerfiles();
  });
})();
